import React from "react";
import { Button } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { motion } from "framer-motion";
import { getCurrencySymbol } from "../../../Custom/Custom";

const MoneyRequestSuccess = ({
  onHome,
  onViewRequests,
  selectedPayee,
  amount,
}) => {
  const currency = getCurrencySymbol
    ? getCurrencySymbol(selectedPayee.nationality)
    : "₹";
  const payeeName = selectedPayee?.name || "Recipient";
  const bankingName =
    selectedPayee?.bankingName ||
    selectedPayee?.name?.toUpperCase() ||
    payeeName.toUpperCase();

  const dateObj = new Date();
  const formattedDate = dateObj.toLocaleString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      style={{
        // minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <motion.div
        key="success"
        initial={{ opacity: 0, y: 44 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -44 }}
        transition={{ duration: 0.42 }}
        style={{
          background: "#fff",
          borderRadius: 22,
          boxShadow: "0 7px 28px rgba(44,80,202,.13)",
          maxWidth: 410,
          width: "94vw",
          padding: "38px 22px 22px 22px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Checkmark */}
        <div
          style={{
            background: "#1976d2",
            borderRadius: "50%",
            height: 88,
            width: 88,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 24,
            boxShadow: "0 2px 12px rgba(25,118,210,0.13)",
          }}
        >
          <CheckCircleFilled style={{ color: "#fff", fontSize: 56 }} />
        </div>
        {/* Amount */}
        <div
          style={{
            fontSize: 34,
            fontWeight: 600,
            letterSpacing: 0,
            marginBottom: 10,
          }}
        >
          {currency}
          {Number(amount).toFixed(2)}
        </div>
        {/* Paid to */}
        <div
          style={{
            fontSize: 18,
            fontWeight: 400,
            opacity: 0.95,
            marginBottom: 3,
          }}
        >
          Requested from
        </div>
        {/* Name */}
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
          {payeeName}
        </div>
        {/* Verified bank name */}
        <div
          style={{
            background: "#eafaf1",
            borderRadius: 8,
            color: "#1da158",
            fontSize: 15,
            display: "inline-flex",
            alignItems: "center",
            padding: "6px 14px",
            marginBottom: 11,
            fontWeight: 500,
            gap: 7,
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 22c5.522 0 10-4.477 10-10S17.522 2 12 2 2 6.477 2 12s4.478 10 10 10zm-1.293-4.707l-3-3a1 1 0 011.414-1.414l1.293 1.293 4.293-4.293a1 1 0 011.414 1.414l-5 5z" />
          </svg>
          Banking name:{" "}
          <span style={{ color: "#22314a", marginLeft: 4 }}>{bankingName}</span>
        </div>
        {/* Date */}
        <div
          style={{
            fontSize: 14,
            opacity: 0.66,
            marginBottom: 22,
            fontWeight: 400,
          }}
        >
          {formattedDate}
        </div>
        {/* Buttons */}
        <Button
          type="primary"
          block
          style={{
            background: "linear-gradient(90deg,#021b79,#0575E6)",
            borderRadius: 12,
            fontWeight: 600,
            fontSize: 16,
            marginBottom: 11,
            height: 48,
            border: "none",
          }}
          onClick={onHome}
        >
          Go back home
        </Button>
        <Button
          type="link"
          block
          style={{
            fontWeight: 600,
            fontSize: 15,
            color: "#22314a",
          }}
          onClick={onViewRequests}
        >
          View all requests
        </Button>
      </motion.div>
    </div>
  );
};

export default MoneyRequestSuccess;
